import { Stack, Tabs, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { CodeSnippet } from '@/components/ui-shared/CodeSnippet/CodeSnippet'
import { CodeExampleToggle } from '../../CodeExampleToggle'
import {
  MQTT_DEFAULT_JSON,
  MQTT_OINSIGHTS_JSON
} from '../../json-examples/mqtt-json-example'

type MqttCodeSnippetProps = {
  title: ReactNode
  code: string
}

const MqttCodeSnippet = ({ title, code }: MqttCodeSnippetProps) => {
  return (
    <div>
      <Text size="xs" fw={600}>
        {title}
      </Text>

      <CodeSnippet maxHeight={320} copyValue={code}>
        {code}
      </CodeSnippet>
    </div>
  )
}

export const MqttJsonExample = () => {
  const [isOpen, { toggle }] = useDisclosure(false)

  return (
    <CodeExampleToggle
      buttonLabel={<FormattedMessage id="integrations.jsonExample" />}
      isOpen={isOpen}
      onClick={toggle}
    >
      <Tabs
        variant="pills"
        defaultValue="default"
        styles={(theme) => ({
          panel: {
            paddingTop: theme.spacing.sm
          },
          tab: {
            padding: 6,
            fontSize: theme.fontSizes.xs
          }
        })}
      >
        <Tabs.List>
          <Tabs.Tab value="default">
            <FormattedMessage id="integrations.mqtt.topics.format.default.label" />
          </Tabs.Tab>

          <Tabs.Tab value="oinsights">
            <FormattedMessage id="integrations.mqtt.topics.format.oinsights.label" />
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="default">
          <Stack gap="md">
            <MqttCodeSnippet
              title={
                <FormattedMessage id="integrations.mqtt.topics.type.periodic_log.label" />
              }
              code={MQTT_DEFAULT_JSON.periodic_log}
            />

            <MqttCodeSnippet
              title={
                <FormattedMessage id="integrations.mqtt.topics.type.event_log.label" />
              }
              code={MQTT_DEFAULT_JSON.event_log}
            />
          </Stack>
        </Tabs.Panel>

        <Tabs.Panel value="oinsights">
          <Stack gap="md">
            <MqttCodeSnippet
              title={
                <FormattedMessage id="integrations.mqtt.topics.type.periodic_log.label" />
              }
              code={MQTT_OINSIGHTS_JSON.periodic_log}
            />

            <MqttCodeSnippet
              title={
                <FormattedMessage id="integrations.mqtt.topics.type.event_log.label" />
              }
              code={MQTT_OINSIGHTS_JSON.event_log}
            />
          </Stack>
        </Tabs.Panel>
      </Tabs>
    </CodeExampleToggle>
  )
}
